import script from "./ReferenceDots.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferenceDots.vue?vue&type=script&setup=true&lang=ts"

import "./ReferenceDots.vue?vue&type=style&index=0&id=872a2dae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-872a2dae"]])

export default __exports__